<template>
  <div class="sign-list">
    <!-- shearch -->
    <navTab navTabArrType="corpSignList" navTabVal="sealApprove" />
    <el-row type="flex" class="row">
      <el-col :span="6"></el-col>
      <el-col :span="6">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-select v-model="searchType" placeholder="请选择" size="small">
              <el-option label="印章名称" :value="0" />
              <el-option label="申请人" :value="1" />
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-input v-model="searchText" size="small" placeholder="查询内容" />
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4">
        <div style="text-align: center; white-space: nowrap">
          <el-select style="width: 140px" v-model="flowStatus" placeholder="请选择" size="small">
            <el-option
              v-for="(item, index) in statusEnum"
              :label="item.label"
              :key="'status' + index"
              :value="item.value"
            />
          </el-select>
        </div>
      </el-col>
      <el-col :span="5">
        <el-row>
          <el-date-picker
            v-model="datePikerArr"
            type="daterange"
            value-format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            style="width: unset"
          />
        </el-row>
      </el-col>
      <el-col :span="3" class="text-right">
        <el-row type="flex">
          <el-col :span="12">
            <el-button @click="searchFn" size="small">查询</el-button>
          </el-col>
          <el-col :span="12">
            <el-button @click="rest" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 数据展示 -->
    <el-table
      :data="tableList"
      v-loading="loading"
      class="data-list"
      ref="dataList"
      tooltip-effect="dark"
      :key="'signlist-' + $route.query.signStatus"
      @cell-mouse-enter="cellMouseEnter"
      @cell-mouse-leave="cellMouseLeave"
      @selection-change="handleSelectionChange"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '500',
      }"
    >
      <!--      <el-table-column type="selection" width="45" />-->
      <el-table-column label width="70" show-overflow-tooltip>
        <template slot-scope="scope"></template>
      </el-table-column>
      <el-table-column label="印章名称" min-width="160" show-overflow-tooltip>
        <template slot-scope="scope">
          <!--          <corp-apply-name applyType="signList"-->
          <!--                           :signInfo="{signStatus: scope.row.signStatus, selfSign: scope.row.selfSign, selfApprove: scope.row.selfApprove, signNo: scope.row.signNo, contractName: scope.row.contractName, applyNo: scope.row.applyNo, approveId: scope.row.approveId}"/>-->
          <div class="seal_name_time" @click="toApplyDetail(scope.row)">
            <div class="seal_name">
              <div class="seal_box">
                <img :src="fileOperShowFn(scope.row.imgPath)" class="seal_img" onerror="this.src='/images/defalutSign.png'" />
              </div>
              <template>
                <el-tooltip effect="dark" content="由钉钉发起的" placement="bottom-start">
                  <img
                    src="/images/icon/dingIcon.png"
                    alt="钉钉"
                    width="20px"
                    v-if="scope.row.flowType === 3 && !isInDingTalk"
                  />
                </el-tooltip>
                <el-tooltip effect="dark" content="由WEB端发起的" placement="bottom-start">
                  <el-tag v-if="isInDingTalk && !(scope.row.flowType === 3)" type="danger" size="small">WEB</el-tag>
                </el-tooltip>
              </template>
              <span class="seal_text"> &nbsp;{{ scope.row.sealName }}</span>
            </div>
            <p>用印文件：{{ scope.row.applyName }}</p>
            <span>发起时间：{{ scope.row.createTime | formatDateHM }}</span>
          </div>
        </template>
      </el-table-column>
      <!--      <el-table-column label="用印文件" min-width="180">-->
      <!--        <template slot-scope="scope">-->
      <!--          <a class="contract_name" @click="toApplyDetail(scope.row)">{{-->
      <!--            scope.row.applyName-->
      <!--          }}</a>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column label="申请人" min-width="160" prop="signatoryName" show-overflow-tooltip />
      <el-table-column label="状态" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <span :class="classFn(scope.row)">{{ statuShowFn(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope" v-if="!(scope.row.applyNo && scope.row.applyNo.startsWith('APLO')) && ($route.query.signStatus == 6) && ((isInDingTalk && scope.row.flowType ===3) || (!isInDingTalk && scope.row.flowType !==3))">
          <span
            class="operation_btn"
            v-if="scope.row.flowStatus === 0 && scope.row.selfApprove !== 1"
            @click="handleproceInfo(scope.row)"
          >审批详情</span>
          <template v-if="isInDingTalk">
            <span
              class="operation_btn"
              v-if="scope.row.flowStatus === 0 && scope.row.selfApprove && scope.row.selfApprove == 1"
              @click="signApproveHandle(scope.row)"
            >审批</span>
          </template>
          <template v-else>
            <div class="operate-box pointer" v-if="scope.row.selfApprove">
              <span class="operation_btn" @click="approveSubmitFn(1, scope.row)">同意</span>
              <span class="operation_btn" @click="approveSubmitFn(2, scope.row)">拒绝</span>
            </div>
          </template>
        </template>
      </el-table-column>
      <no-data text="暂无数据" slot="empty" />
    </el-table>
    <div
      class="bulkOperation"
      v-if="
        batchLength &&
        (!$route.query.signStatus || $route.query.signStatus !== 2)
      "
    >
      已选{{ batchLength }}份文件
      <!--      <el-button-->
      <!--        v-if="+$route.query.signStatus !== 2"-->
      <!--        @click="batchDown"-->
      <!--        size="small"-->
      <!--        >下载-->
      <!--      </el-button>-->
    </div>
    <!--分页栏-->
    <el-row class="pageation row" :style="{ marginLeft: !$route.query.signStatus ? '70px' : 0 }">
      <el-col :span="24" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="screenParme.itemPage"
          :pager-count="5"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="screenParme.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="pageTotal"
        />
        <el-go
          :page-size="screenParme.pageSize"
          :total="pageTotal"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
    <!-- 钉钉环境带他审详情弹窗 -->
    <approval-info-pup :proceVisi="proceVisi" :approvalInof="approvalInof" @close="handleClose"></approval-info-pup>

    <!-- 拒绝原因 Dialog -->
    <el-dialog
      :visible.sync="dialogAuditRefuseVisible"
      :title="refuseModel.flowStatus === 2 ? '拒绝原因' : '审批意见'"
      width="500px"
    >
      <el-row>
        <el-col :span="24">
          <div style="position: relative">
            <el-input
              ref="textareaReason"
              type="textarea"
              v-model="refuseModel.reason"
              rows="5"
              resize="none"
              :autofocus="true"
              size="small"
              :maxlength="100"
              :placeholder="refuseModel.flowStatus === 2 ? '请输入拒绝原因' : '请输入审批意见'"
            />
            <span style="position:absolute;bottom: 10px;right: 10px;color: red;"
            >{{ refuseModel.reason.length }}/100</span
            >
          </div>
        </el-col>
        <el-col :span="24" style="height: 24px">
          <p v-if="refuseModel.errorMessage" style="color: red;">
            {{ refuseModel.errorMessage }}
          </p>
        </el-col>
      </el-row>
      <p slot="footer" class="dialog-footer">
        <el-button
          @click="dialogAuditRefuseVisible = false"
          size="small"
          class="btn"
        >取消</el-button
        >
        <el-button
          @click="clickHandleRefuseSubmit()"
          type="danger"
          size="small"
          class="btn"
        >提交</el-button
        >
      </p>
    </el-dialog>
  </div>
</template>
<script>
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import {
  ApiCorpMethods,
  signViewUrl,
  applyViewUrl
} from "@/assets/js/http-serve/corp/http-methods";
import ElGo from "@/components/go/Go";
import CorpApplyName from "@/components/apply-list/corpContractName";
import { fileOperShow } from "@/assets/js/http-serve/http-methods";
import { isInDingTalk } from '@/assets/js/utils/ding-env'
import GlobalConfig from '../../../assets/js/config/global';
import approvalInfoPup from "./components/approvalInfoPup.vue";
import navTab from '@/components/nav-tab/navTab';
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi";

export default {
  name: "sealApproval",
  components: {
    ElGo,
    CorpApplyName,
    approvalInfoPup,
    navTab,
  },
  data () {
    return {
      dialogAuditRefuseVisible: false, //拒绝弹窗
      refuseModel: {
        data: {},
        reason: '',
        errorMessage: '',
        approveOpinion: '',
        flowStatus: '',
      },
      isInDingTalk,
      navTabVal: 'corpMySign',
      proceVisi:false, // 审批详情弹窗
      approvalInof:{},
      // fileOperShow: fileOperShow, //引入方法
      loading: false,
      searchType: 0, //类型
      searchText: "", //文字
      datePikerArr: [],
      tableList: [],
      batchLength: "", //已选择文件数
      pageTotal: 0,
      flowStatus: 0, //状态
      statusEnum: [
        { label: "全部", value: "" },
        { label: "待审批", value: 0 },
        { label: "已通过", value: 1 },
        { label: "已驳回", value: 2 }
      ],
      batchApplyNos: "", //下载文件
      screenParme: {
        sealId: "", //印章ID，未用
        corpUserQueryId: "", //申请人ID
        signatoryName: "", //名称
        sealName: "", //印章名称
        beginDate: "",
        endDate: "",
        itemPage: 1,
        pageSize: 10
      }
    };
  },
  inject: ["reload"],
  mounted () {
    this.getSealList();
  },
  destroyed () {
    this.batchLength = null;
    this.$emit("batchLength", this.batchLength);
  },
  computed: {
    viewUrl () {
      //就用第一个
      if (this.applyType === "signList" || true) {
        return signViewUrl;
      } else if (this.applyType === "applyList") {
        return applyViewUrl;
      }
    }
  },
  watch: {
    datePikerArr: {
      handler (val) {
        if (val && val.length === 2) {
          this.screenParme.beginDate = val[0];
          this.screenParme.endDate = val[1];
        } else {
          this.screenParme.beginDate = this.screenParme.endDate = null;
        }
      },
      deep: true
    }
  },
  methods: {
    //审批意见提交
    clickHandleRefuseSubmit() {
      if (this.refuseModel.flowStatus === 1) {
        this.executeAudit();
      } else if (this.refuseModel.flowStatus === 2) {
        this.handleBlur();
        if (!this.refuseModel.errorMessage) {
          this.executeAudit();
        }
      }
    },
    executeAudit() {
      ApiCorpMethods.CorpSealSignInfoController.approveSeal({
        partyId: this.refuseModel.data.approveId,
        sign: this.refuseModel.data.sign,
        ts: this.refuseModel.data.ts,
        reason: this.refuseModel.reason,
        approveStatus: this.refuseModel.flowStatus,
      }).then(res => {
        if (res.success) {
          this.getSealList();
          this.$message({
            type: "success",
            message: `操作成功`
          });
          this.dialogAuditRefuseVisible = false;
        } else {
          this.$message({
            type: "error",
            message: res.code === '10103' ? '当前审批流程已失效' : res.description || '请重试',
          });
        }
      });
    },
    // 拒绝原因失去焦点事件
    handleBlur() {
      let v = this.refuseModel.reason;
      if (v) {
        if (v.length > 100) {
          this.refuseModel.errorMessage = "不能超过100个字";
        } else {
          this.refuseModel.errorMessage = "";
        }
      } else {
        this.refuseModel.errorMessage = "请输入拒绝原因审批意见";
      }
    },
    /** 审批详情弹窗关闭 */
    handleClose(){
      this.proceVisi = false
      this.approvalInof={}
    },
    /** 钉钉用印审批 */
    signApproveHandle(row){
      if(isInDingTalk && row.flowType !== 3) return this.$message.warning('如需审批或查看审批详情，请前往君子签SaaS')
      if(!isInDingTalk && row.flowType == 3) return this.$message.warning('如需审批或查看审批详情，请前往钉钉君子签微应用')
      const
        { dingTalkCorpId: corpId, dingTalkUserId } = JSON.parse(sessionStorage.getItem("dingloginInfo")),
        {extendId:sealId,applyNo,signNo} = row,
        _this = this;
      const param = {corpId,dingTalkUserId,sealId,applyNo,signNo}
      dingtalkApi.sealFlowUrl(param).then(res=>{
        if(!res.success) return _this.$message.error(res.description)
        this.$DingSDKPromise().then((SDK)=>{
          /** 钉钉弹窗逻辑 */
          SDK.biz.util.openSlidePanel({
            url: res.data, //打开侧边栏的url
            title: '用印审批', //侧边栏顶部标题
            onSuccess: function (result) { },
            onFail: function () { }
          }).catch((err) => { console.log('跳转用印钉钉oa审批-catch_err：', err); })
        }).catch(err=>{
          console.error('钉钉环境准备失败:',err);
        });
      })
    },
    /** 查看审批详情 */
    handleproceInfo(row){
      if(isInDingTalk && row.flowType !== 3) return this.$message.warning('如需审批或查看审批详情，请前往君子签SaaS')
      if(!isInDingTalk && row.flowType == 3) return this.$message.warning('如需审批或查看审批详情，请前往钉钉君子签微应用')
      if(isInDingTalk){
        this.dingQueryInfo(row)
      }else{
        ApiCorpMethods.CorpAuditContractController.flowInstInfo({instIdNo:row.instIdNo}).then(res=>{
          if(!res.success) return this.$message.error(res.description)
          this.approvalInof={...res.data,approRowInfo:row}
        })
      }
      this.proceVisi = true
    },
    /** 用印审批详情 */
    dingQueryInfo(row){
      const
        { dingTalkCorpId: corpId, dingTalkUserId } = JSON.parse(sessionStorage.getItem("dingloginInfo")),
        {applyNo,signNo,extendId:sealId} = row,
        _this = this;
      const param = { corpId, dingTalkUserId, applyNo,sealId,signNo }
      dingtalkApi.dingSealTaskList(param).then(res=>{
        if(!res.success) return _this.$message.error(res.description)
        this.approvalInof={...res.data,approRowInfo:row}
      })
    },
    //获取优先级类型
    getPriorityTypeList () {
      ApiMethods.CorpUserTagController.getAllUserTagList(this.screenParme);
    },
    //审批
    approveSubmitFn (type, data) {
      this.refuseModel.data = data;
      this.refuseModel.reason = "";
      this.refuseModel.flowStatus = type;
      this.refuseModel.errorMessage = "";
      this.dialogAuditRefuseVisible = true;
    },
    // 重置
    rest () {
      this.searchType = 0; //类型
      this.searchText = ""; //文字
      this.datePikerArr = [];
      this.flowStatus = 0; //状态
      this.searchFn();
    },
    //searchFn
    searchFn () {
      this.screenParme.itemPage = 1;
      this.getSealList();
    },
    //列表
    getSealList () {
      let params = {
        ...this.screenParme,
        flowStatus: this.flowStatus
      };
      //=-=
      if (this.searchText) {
        if (this.searchType === 0) {
          params.sealName = this.searchText;
        } else {
          params.signatoryName = this.searchText;
        }
      }
      ApiCorpMethods.CorpAuditContractController.approverContractList(
        params
      ).then(res => {
        this.tableList = res.data;
        this.pageTotal = res.total;
        this.$emit("update:badge", res.total);
      });
    },
    //图片显示fileOperShowFn
    fileOperShowFn (data) {
      return data ? fileOperShow(data) : "";
    },
    //状态回显
    statuShowFn (data) {
      switch (data.flowStatus) {
        case 0:
          if (data.selfApprove === 1) {
            return "待我审";
          } else {
            return "待ta审";
          }
        case 1:
          return "已通过";
        case 2:
          return "已拒绝";
      }
    },
    classFn (data) {
      switch (data.flowStatus) {
        case 0:
          if (data.selfApprove === 1) {
            return "await_me";
          } else {
            return "await_you";
          }
        case 1:
          return "pass_class";
        case 2:
          return "refuse_class";
      }
    },
    //文件详情
    toApplyDetail (data) {
      // 判断是否国际版发起的合同，如果不是就提示去国内版本签署(当合同applyNo以APLO开头时，说明是国际版发起的合同)
      if((data.applyNo && data.applyNo.startsWith('APLO'))){
        return this.$message.warning('国际版发起的文件请前往 FairSigning操作!');
      }
      if(isInDingTalk && data.flowType !== 3) return this.$message.warning('如需审批或查看审批详情，请前往君子签SaaS')
      if(!isInDingTalk && data.flowType == 3) return this.$message.warning('如需审批或查看审批详情，请前往钉钉君子签微应用')
      // 两种接口（发起、收到）
      this.viewUrl({
        approveId: data.approveId,
        // applyNo: data.applyNo,
        signNo:data.signNo,
        instIdNo:data.instIdNo,
        multiFile: data.multiFile,
        selfApprove: data.selfApprove,
        chapterSign: data.sign,
        chapterTs: data.ts,
        extendId:data.extendId
      })
        .then(url => {
          if (url) {
            let newWindow;
            if (!isInDingTalk) {
              try {
                newWindow = window.open();
                newWindow.location.href = url + '&sealImgPath=' + JSON.stringify(data.imgPath);
              } catch (e) {
                let domain = GlobalConfig.domain;
                let src = url.replace(domain.junziqianWebOp, '');
                const href = this.$router.resolve({
                  path: src,
                  query: {
                    sealImgPath: JSON.stringify(data.imgPath),
                  },
                }).href;
                window.open(href, "_blank");
              }
            } else {
              // location.href = url
              this.$router.push(url)
            }
          } else {
            this.$message.error(res.description || "");
          }
        })
        .catch(err => {
          this.$message.error(err.description || "请重试.");
        });
    },
    //cellMouseEnter
    cellMouseEnter () { },
    cellMouseLeave () { },
    handleSelectionChange (val) {
      this.batchLength = val.length;
      this.$emit("batchLength", this.batchLength);
      this.batchApplyNos = "";
      if (!val || !val.length) return;
      this.batchApplyNos = (val || []).map(i => i.applyNo).join(",");
    },
    batchDown () {
      if (!this.batchApplyNos)
        return this.$confirm("请先选择需要下载的签署。", "系统提示", {
          showConfirmButton: true,
          showCancelButton: false
        });
      ApiCorpMethods.CorpApplyContractController.downloadBatch({
        applyNos: this.batchApplyNos
      })
        .then(res => {
          if (!res.success)
            return this.$message.error(res.description || this.$tip);
          this.downloadFile(res.data);
        })
        .finally(() => (this.loading = false));
    },
    async downloadFile (param) {
      param.fix = ".zip";
      let res = await ApiMethods.FileOperController.download_get(param);
      if (res.success && res.url) {
        window.location.href = res.url;
      } else {
        this.$message.error(res.err);
      }
    },
    // 分页
    handleSizeChange (val) {
      this.screenParme.itemPage = 1;
      this.screenParme.pageSize = val;
      this.getSealList();
    },
    handleCurrentChange (val) {
      this.screenParme.itemPage = val;
      this.getSealList();
    }
  }
};
</script>

<style lang="less" scoped>
  .dialog-footer {
    padding-bottom: 20px;
  }
.refuse_class {
  color: #e9b810;
}
.await_me {
  color: #eb090a;
}
.await_you {
  color: #10a0e9;
}
.pass_class {
  color: #009899;
}
.contract_name {
  cursor: pointer;
  text-overflow: ellipsis;
  color: #290202;
  font-weight: 800;
  font-size: 16px;

  &:hover {
    color: #ec1c1c;
  }
}

.seal_name_time {
  cursor: pointer;
  .seal_name {
    display: flex;
    align-items: center;
    .seal_box {
      width: 68px;
      height: 68px;
      margin-right: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      .seal_img {
        max-width: 68px;
      }
    }
    .seal_text {
      font-weight: bold;
      font-size: 15px;
      color: #000000;
    }
  }
}

.operate-box {
  /*  display: flex; */
  justify-content: flex-start;
  align-items: center;
}
.operation_btn {
  display: inline-block;
  margin-right: 8px;
  cursor: pointer;
  color: #290202;
  font-weight: bold;
}

.operation_btn:hover {
  color: #ec1c1c;
}

.hover-win {
  padding: 5px;

  .icontag:hover {
    background: whitesmoke;
  }
}

.icontag {
  color: #ddd;
}

.textEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #290202;
  opacity: 0.65;
}

.bulkOperation {
  width: 85%;
  height: 50px;
  background: #f9f9f9;
  position: absolute;
  top: 99px;
  left: 140px;
  display: flex;
  align-items: center;
  color: rgba(41, 2, 2, 0.45);

  /deep/ .el-button {
    background: rgba(236, 28, 28, 1);
    color: #ffffff;
    margin-left: 10px;

    &:hover {
      opacity: 0.7;
    }
  }
}

.multiFile {
  position: absolute;
  font-size: 12px;
  top: 0px;
  left: -12px;
  width: 22px;
  height: 16px;
  line-height: 16px;
  background-color: #eb090a;
  color: #ffffff;
  text-align: center;
  border-radius: 4px;
  transform: scale(0.8);
  z-index: 2;

  &:after {
    content: "";
    position: absolute;
    bottom: -4px;
    right: 4px;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid #eb090a;
    z-index: 1;
  }
}

.operation span {
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
}

.query-label {
  font-weight: 600;
  white-space: nowrap;
}

.insurance-info .info-box {
  padding: 0 20px 20px 20px;

  p {
    margin-bottom: 10px;
  }

  .title {
    vertical-align: top;
    display: inline-block;
    text-align: right;
    width: 100px;
    margin-right: 10px;
  }

  .box {
    display: inline-block;
  }
}

.insurance-dialog .insurance-form {
  width: 80%;
  margin: 0 auto 40px auto;

  .btn {
    width: 220px;
  }
}

.file-name {
  display: inline-block;
  cursor: pointer;

  i {
    display: inline-block;
    width: 22px;
    height: 18px;
    position: absolute;
    top: 15px;
    left: -13px;
  }
}

.action {
  span {
    cursor: pointer;
  }
}

.sign-list {
  max-width: 1200px;
  margin: 0 auto;

  .color-success {
    cursor: pointer;
  }

  .pageation {
    padding: 30px 10px 20px 10px;
    border-top: 0;
    min-height: 85px;
  }

  .dialog-footer {
    padding-bottom: 20px;

    /*.btn {*/
    /*  width: 30%;*/
    /*}*/
  }

  nav.nav-bar {
    width: 100%;
    margin-top: 20px;
    border: 1px dashed #d7d7d7;
    overflow: hidden;

    li.nav-item {
      margin-right: 14px;
      padding: 10px 15px;
      color: #666;
      border: none;
      background: #fff;
      cursor: pointer;
    }

    .nav-item.active {
      color: #ec1c1c;
    }

    ul.nav {
      width: 100%;
    }
  }
}

.tag-flag {
  display: inline-block;
  height: 18px;
  width: 19px;
  /*background-image: url(/images/icon/icon-flag.png);*/
  background-size: cover;
  background-repeat: no-repeat;
}

.tip-flag-1 {
  background-color: #faca32;
}

.tip-flag-2 {
  background-color: #71ac74;
}

.tip-flag-3 {
  background-color: #da4848;
}

.tip-flag-4 {
  background-color: #e5a196;
}

.tip-flag-5 {
  background-color: #615044;
}

.tip-flag-6 {
  background-color: #f79448;
}

.tip-flag-7 {
  background-color: #8181c1;
}

.tip-flag-8 {
  background-color: #895fa7;
}

.tip-flag-9 {
  background-color: #34699a;
}

.tip-flag-10 {
  background-color: #468a8c;
}

.flagActive {
  border: 1px solid red;
}

.ly-mask {
  .tips {
    color: rgb(115, 90, 90);
    font-size: 12px;
    text-align: left;
  }

  .box-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-left: -20px;
    margin-top: -15px;
    padding: 15px;

    &:last-child {
      /* margin-bottom: 130px; */
    }

    .temone {
      position: relative;
      margin: 15px 0 0 20px;
      width: 175px;
      text-align: center;
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;

      &.add {
        cursor: pointer;
        height: 140px;
        line-height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;

        .file-ipt {
          width: inherit;
          height: inherit;
          position: absolute;
          opacity: 0;
        }

        &:hover {
          box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
        }
      }

      &.temone-center {
        height: 140px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .t-box {
          width: 100%;
          height: 75%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          overflow: hidden;

          .y-img {
            margin-top: 0;
          }
        }

        .tpid {
          width: 100%;
          height: 25%;
          background: #eeeeee;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      &:hover {
        .t-box {
          .msk {
            width: 100%;
            height: 100%;
            opacity: 1;
          }
        }

        .has-hover {
          display: block;
        }

        .no-hover {
          display: none;
        }
      }

      .t-box {
        position: relative;
        height: 105px;
        overflow: hidden;

        .y-img {
          width: 46px;
          height: 54px;
          display: block;
          margin: 17px auto 7px auto;
        }

        p {
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 0 10px;
          width: 100%;
          font-family: Source Han Sans SC;
          color: rgba(41, 2, 2, 0.65);
          box-sizing: border-box;
        }

        .msk {
          transition: all ease 0.2s;
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          background: rgba(0, 0, 0, 0.5);
          opacity: 0;
          padding: 8px 8px;
          box-sizing: border-box;

          .des {
            margin-top: 20px;
            color: #ffffff;
            font-size: 12px;
            text-align: left;
          }

          span {
            cursor: pointer;
            color: #ffffff;
            margin-left: 10px;
          }
        }
      }

      .b-box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        a {
          width: 50%;
        }
      }

      .el-icon-plus {
        cursor: pointer;
        color: #c9bfbf;
        font-size: 80px;
      }
    }
  }

  .a-btn {
    cursor: pointer;
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: rgba(41, 2, 2, 1);
    text-decoration: none;
    border-radius: 0px 0px 4px 4px;
    background: rgba(239, 239, 239, 1);

    a {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;

      &:hover {
        color: rgba(236, 28, 28, 1);
      }
    }

    .has-hover {
      display: none;
    }

    .no-hover {
      display: block;
    }
  }
}

/deep/ .ly-info .el-tabs__item.is-active {
  color: rgb(236, 28, 28);
}

/deep/ .ly-info .el-tabs__active-bar {
  background-color: rgb(236, 28, 28);
}

/deep/ .ly-info .el-tabs__item {
  color: rgb(158, 140, 140);
}

.footer {
  height: 50px;
  position: relative;

  .num {
    margin-left: 20px;
    font-size: 14px;
    color: rgb(140, 140, 140);

    label {
      color: #ec1c1c;
    }
  }

  .cancel-btn {
    border-width: 1px;
    border-color: rgb(176, 164, 164);
    border-style: solid;
    border-radius: 3px;
    width: 62px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    position: absolute;
    right: 20px;
    color: rgb(178, 165, 165);
    cursor: pointer;
  }
}

/deep/ .ly-info .el-dialog__body {
  height: 420px;
  overflow-y: auto;
}

/deep/ .ly-info .el-dialog__footer {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// pages/corp/signInfo/sealApproval.vue